import { render } from "./SwDataTable.vue?vue&type=template&id=58d2c402"
import script from "./SwDataTable.vue?vue&type=script&lang=js"
export * from "./SwDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__